import { computed, ComputedRef } from 'vue'

import { Participant } from '@collector/sportsapi-client-legacy'
import { useInvertedParticipants } from '@desktop/views/Relation/composables'

import { useEventDetailHalf } from './useEventDetailHalf'

/**
 * Returns the batting `Participant` based on the current value of event detail `Half`.
 */
export function useBaseballParticipants(): {
  pitchingParticipant: ComputedRef<Participant | undefined>
  battingParticipant: ComputedRef<Participant | undefined>
} {
  const { firstParticipant, secondParticipant } = useInvertedParticipants()
  const { eventDetailHalfValue } = useEventDetailHalf()

  const battingParticipant = computed(() => {
    if (eventDetailHalfValue.value === 'top') {
      return secondParticipant.value
    }
    return firstParticipant.value
  })

  const pitchingParticipant = computed(() => {
    if (eventDetailHalfValue.value === 'top') {
      return firstParticipant.value
    }
    return secondParticipant.value
  })

  return { pitchingParticipant, battingParticipant }
}
